







































































































































































































import { computed, defineComponent, getCurrentInstance, onMounted, ref, watch } from "vue";
import {
  CPopover,
  CPopoverArrow,
  CPopoverBody,
  CPopoverCloseButton,
  CPopoverContent,
  CPopoverTrigger
} from "@chakra-ui/vue";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import {
  BOA_HORA_CALENDAR_LOCALE,
  describePregnancy,
  formatIsoDate,
  parseIsoDate,
  readBoaHora,
  saveBoaHora,
  toIsoDate
} from "@/utils/programaBoaHora";

const pregnancyImages = {
  "trimestre-1": process.env.VUE_APP_BASE_URL + "images/health_programs/boa-hora-trimestre-1.png",
  "trimestre-2": process.env.VUE_APP_BASE_URL + "images/health_programs/boa-hora-trimestre-1.png",
  "trimestre-3": process.env.VUE_APP_BASE_URL + "images/health_programs/boa-hora-trimestre-3.png",
  "pos-parto": process.env.VUE_APP_BASE_URL + "images/health_programs/boa-hora-mae.png"
};

export default defineComponent({
  components: {
    FixedButtonRow,
    CPopover,
    CPopoverArrow,
    CPopoverBody,
    CPopoverCloseButton,
    CPopoverContent,
    CPopoverTrigger
  },
  setup() {
    const context = getCurrentInstance().proxy;
    const dueDate = ref<string | null>(null);
    const showCalendar = ref(false);
    const hasAppointment = ref(false);
    const calendarLocale = BOA_HORA_CALENDAR_LOCALE;

    const dueDateLabel = computed(() => formatIsoDate(dueDate.value) || "dd/mm/aaaa");
    const calendarAttributes = computed(() => [
      {
        key: "selected-date",
        highlight: true,
        dates: dueDate.value ? parseIsoDate(dueDate.value) : null
      }
    ]);
    const snapshot = computed(() => (dueDate.value ? describePregnancy(dueDate.value) : null));
    const coverImage = computed(() => pregnancyImages[snapshot.value?.image || "trimestre-1"]);
    const actionLabel = computed(() => {
      if (!dueDate.value) return "Agendar primeira consulta";
      return hasAppointment.value ? "Ver consulta" : "Agendar consulta";
    });

    onMounted(() => {
      context.$root.$emit("hide-loading");
      const record = readBoaHora(context.$store.state.saude.vinculo);
      if (!record.joined) {
        context.$router.replace({ name: "programa_saude_2.boa_hora" });
        return;
      }
      dueDate.value = record.dueDate;
      hasAppointment.value = !!record.appointment;
    });

    watch(dueDate, value => {
      if (!value) return;
      saveBoaHora(context.$store.state.saude.vinculo, { dueDate: value, joined: true });
    });

    const onDueDate = day => {
      if (!day?.date) return;
      dueDate.value = toIsoDate(day.date);
      showCalendar.value = false;
    };

    const onNativeDate = (event: Event) => {
      const value = (event.target as HTMLInputElement).value;
      dueDate.value = value || null;
    };

    const goNext = () => {
      if (!dueDate.value) return;
      context.$router.push({
        name: hasAppointment.value ? "programa_saude_2.boa_hora.consulta" : "programa_saude_2.boa_hora.agendamento"
      });
    };

    return {
      coverImage,
      dueDate,
      snapshot,
      actionLabel,
      dueDateLabel,
      showCalendar,
      calendarLocale,
      calendarAttributes,
      onDueDate,
      onNativeDate,
      goNext
    };
  }
});
